import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import Button from './../../forms/Button';
import { useDispatch } from 'react-redux';
import { addProduct } from './../../../redux/Cart/cart.actions';
import { fetchProductsFilter } from '../../../redux/Products/products.sagas';

const Product = (productsft) => {
  const dispatch = useDispatch();

  var nf = new Intl.NumberFormat();
  
  const history = useHistory();
  const {
    documentID,
    image,
    pname,
    price
  } = productsft;
  if (!documentID || !image || !pname ||
    typeof price === 'undefined') return null;

  const configAddToCartBtn = {
    type: 'button'
  };

  const handleAddToCart = (productsft) => {
    if (!fetchProductsFilter) return;
    dispatch(
      addProduct(productsft)
    );
    history.push('/cart');
  };

  return (
    <div className="productflt">
      <div className="thumb">
        <Link to={`/product/${documentID}`}>
          <img src={image} alt={pname} />
        </Link>
      </div>

      <div className="details">
        <ul>
          <li>
            <span className="name">
              <Link to={`/product/${documentID}`}>
                {pname}
              </Link>
            </span>
          </li>
          <li>
            <span className="price">
            {'\u20A6'}{nf.format(price)}
            </span>
          </li>
          <li>
            <div className="addToCart">
              <Button {...configAddToCartBtn} onClick={() => handleAddToCart(productsft)}>
                Add to cart
              </Button>
            </div>
          </li>
        </ul>
      </div>

    </div>
  );
};

export default Product;